import React from 'react';
import EventFeedbackQuestionList from "../../features/EventManagement/EventFeedbackQuestionList";

 const EventFeedbackQuestion = () =>{
    return(<>
    <EventFeedbackQuestionList/>
    </>)
}
export default EventFeedbackQuestion;